import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-client-information',
  templateUrl: './client-information.component.html',
  styleUrls: ['./client-information.component.scss']
})
export class ClientInformationComponent implements OnInit {

  @Input() debtorInformation;

  constructor() { }

  ngOnInit(): void {
  }

}
